<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Ställe
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="mb-4">
                    <label for="search" class="block text-sm font-medium text-gray-700">Suche</label>
                    <div class="mt-1">
                        <input type="text" name="search" id="search" v-model="search" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Produktsuche">
                    </div>
                </div>
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Pferde
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Bruttopreis
                                            </th>
                                            <th scope="col" class="relative px-6 py-3">
                                                <span class="sr-only">Bearbeiten</span>
                                                <button @click="addStable = true" type="button" class="inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    <PlusIcon class="h-5 w-5" aria-hidden="true" />
                                                </button>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <!-- Odd row -->
                                        <template v-for="(stable, i) in stables.filter(item => { for(x of ['name']) {if(item[x].toLowerCase().includes(search.toLowerCase())) return true} return false})">
                                            <tr :class="i%2 == 0 ? 'bg-white' : 'bg-gray-50'">
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ stable.name }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ stable.horse_count }} Stück
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ stable.price_string }}
                                                    <span v-if="!stable.price_string" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800">
                                                        <ExclamationIcon class="w-4 h-4 text-red-400 mr-3" />
                                                        Kein Preis vorhanden
                                                    </span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    <button @click="stable_edit = stable" class="text-indigo-600 hover:text-indigo-900 ml-4 cursor-pointer">Preise einsehen/festlegen</button>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jet-dialog-modal :show="addStable">
            <template #title>
                Neuen Stall anlegen
            </template>

            <template #content>
                <h1 class="mt-5 text-base font-semibold text-indigo-600 tracking-wide uppercase">Name</h1>
                <div class="md:col-span-5">
                        <label for="name" class="block text-sm font-medium text-gray-700" >
                            Name
                        </label>
                        <div class="mt-1">
                            <input type="text"  id="name" v-model="addStableForm.name" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="addStableForm.errors.name" />
                        </div>
                </div>
                <h1 class="mt-5 text-base font-semibold text-indigo-600 tracking-wide uppercase">Preis festlegen</h1>
                <div class="md:grid-cols-12 md:grid md:gap-4 mt-3">
                    <div class="md:col-span-12">
                        <label for="product" class="block text-sm font-medium text-gray-700" >
                            Produkt
                        </label>
                        <div class="mt-1">
                            <VueNextSelect
                                id="product"
                                :options="products"
                                :label-by="(x) => x.name"
                                value-by="id"
                                searchable
                                clear-on-close
                                close-on-select
                                search-placeholder="Produkt auswählen"
                                v-model="addStableForm.product"
                            />
                            <jet-input-error :message="addStableForm.errors.product" />
                        </div>
                    </div>
                    <div class="md:col-span-5">
                        <label for="price" class="block text-sm font-medium text-gray-700" >
                            Preis
                        </label>
                        <div class="mt-1">
                            <input type="number"  id="price" step="0.01" v-model="addStableForm.price" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="addStableForm.errors.price" />
                        </div>
                    </div>
                    <div class="md:col-span-5">
                        <label for="empty_price" class="block text-sm font-medium text-gray-700" >
                            Leerpreis
                        </label>
                        <div class="mt-1">
                            <input type="number"  id="empty_price" step="0.01" v-model="addStableForm.empty_price" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="addStableForm.errors.empty_price" />
                        </div>
                    </div>
                    <div class="md:col-span-2">
                        <label for="vat" class="block text-sm font-medium text-gray-700" >
                            Umsatzsteuer
                        </label>
                        <div class="mt-1">
                            <input type="number" id="vat" v-model="addStableForm.vat" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="addStableForm.errors.vat" />
                        </div>
                    </div>
                    <div class="flex justify-end md:col-span-12">
                        <button @click="addStableForm.post(route('stables.store', farm), {
                        onSuccess: () => {
                            addStable = false
                        }
                    })" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Stall hinzufügen
                        </button>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <button @click="stable_edit = false" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Schließen
                    </button>
                </div>
            </template>
        </jet-dialog-modal>
        <jet-dialog-modal :show="stable_edit">
            <template #title>
                Preishistorie {{ stable_edit.name }}
            </template>

            <template #content>
                <div class="flex flex-col">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Name
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Datum
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Preis (Leer)
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Ust
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, itemIdx) in stable_edit.price_history" :class="itemIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {{ item.name }}
                                            <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium ml-4" :class="new Date(item.pivot.in_effect_from).setHours(0,0,0,0) > new Date().setHours(0,0,0,0) ? 'bg-green-100 text-green-800' : item.pivot.in_effect_till ? new Date(item.pivot.in_effect_till) >= new Date() ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800' : 'bg-indigo-100 text-indigo-800' ">
                                                {{ new Date(item.pivot.in_effect_from).setHours(0,0,0,0) > new Date().setHours(0,0,0,0) ? 'Zukünftiger Preis' : item.pivot.in_effect_till ? new Date(item.pivot.in_effect_till).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0) ? 'Aktueller Preis (befristet)' : 'Alter Preis' : 'Aktueller Preis'  }}
                                            </span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ new Intl.DateTimeFormat('de-DE').format(new Date(item.pivot.in_effect_from)) }}
                                            <template v-if="item.pivot.in_effect_till">
                                                -
                                                {{ new Intl.DateTimeFormat('de-DE').format(new Date(item.pivot.in_effect_till)) }}
                                            </template>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 4 }).format(item.pivot.value) }}
                                            ({{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 4 }).format(item.pivot.value_empty) }})
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ item.pivot.vat }} %
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 class="mt-5 text-base font-semibold text-indigo-600 tracking-wide uppercase">Preis ändern</h1>
                <div class="mt-5">
                    <label for="email" class="block text-sm font-medium text-gray-700">Datum des Inkrafttretens</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input type="date" name="email" id="email" class="block w-full sm:text-sm rounded-md"  :class="new Date(dateForm.date) < new Date(farm.last_export) ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500 pr-10' : 'focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 text-gray-700' " v-model="dateForm.date" />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="new Date(dateForm.date) < new Date(farm.last_export)">
                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="new Date(dateForm.date) < new Date(farm.last_export)">Das inkrafttreten des Preises kann nicht vor dem letzten Export ({{ new Intl.DateTimeFormat().format(new Date(farm.last_export)) }}) liegen. Sollte dies ein Fehler <strong>und der Export nocht nicht verarbeitet worden</strong> sein, so können Sie unseren Support kontaktieren.<br><u><strong>Sie können diese Meldung ignorieren. Als Datum des Inkrafttrens wird dann der erste Tag nach dem letzten Export, also der {{ new Intl.DateTimeFormat().format(new Date(new Date(farm.last_export).setDate(new Date(farm.last_export).getDate() + 1))) }} gewählt.</strong></u></p>
                </div>
                <div class="md:grid-cols-12 md:grid md:gap-4 mt-3">
                    <div class="md:col-span-12">
                        <label for="product" class="block text-sm font-medium text-gray-700" >
                            Produkt
                        </label>
                        <div class="mt-1">
                            <VueNextSelect
                                id="product"
                                :options="products"
                                :label-by="(x) => x.name"
                                value-by="id"
                                searchable
                                clear-on-close
                                close-on-select
                                search-placeholder="Produkt auswählen"
                                v-model="dateForm.product"
                            />
                            <jet-input-error :message="dateForm.errors.product" />
                        </div>
                    </div>
                    <div class="md:col-span-5">
                        <label for="price" class="block text-sm font-medium text-gray-700" >
                            Preis
                        </label>
                        <div class="mt-1">
                            <input type="number"  id="price" step="0.01" v-model="dateForm.price" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="dateForm.errors.price" />
                        </div>
                    </div>
                    <div class="md:col-span-5">
                        <label for="empty_price" class="block text-sm font-medium text-gray-700" >
                            Leerpreis
                        </label>
                        <div class="mt-1">
                            <input type="number"  id="empty_price" step="0.01" v-model="dateForm.empty_price" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="dateForm.errors.empty_price" />
                        </div>
                    </div>
                    <div class="md:col-span-2">
                        <label for="vat" class="block text-sm font-medium text-gray-700" >
                            Umsatzsteuer
                        </label>
                        <div class="mt-1">
                            <input type="number" id="vat" v-model="dateForm.vat" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="dateForm.errors.vat" />
                        </div>
                    </div>
                    <div class="flex justify-end md:col-span-12">
                        <button @click="dateForm.post(route('stables.prices.store', stable_edit), {
                        onSuccess: () => {
                            stable_edit = false
                        }
                    })" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Preis hinzufügen
                        </button>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <button @click="stable_edit = false" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Schließen
                    </button>
                </div>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import HorseEdit from "@/Modules/HorseEdit";
import Button from "@/Jetstream/Button";
import FarmTitle from "@/Layouts/FarmTitle";
import { ExclamationIcon, ExclamationCircleIcon, PlusIcon } from "@heroicons/vue/solid";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInputError from "@/Jetstream/InputError";
import VueNextSelect from 'vue-next-select';

export default {
    name: "Farm",
    components: {FarmTitle, Button, HorseEdit, AppLayout, ExclamationIcon, ExclamationCircleIcon, PlusIcon, JetDialogModal, JetInputError, VueNextSelect},
    props: ['farm', 'products', 'stables'],
    data: function () {
        return {
            search: '',
            stable_edit: false,
            dateForm: this.$inertia.form({
                date: new Date().toISOString().split('T')[0],
                price: 0,
                empty_price: 0,
                vat: 19,
                product: null
            }),
            addStable: false,
            addStableForm: this.$inertia.form({
                name: '',
                price: 0,
                empty_price: 0,
                vat: 19,
                product: null
            })
        }
    }
}
</script>

<style>
@keyframes loading{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}.icon.delete{display:flex;justify-content:center;align-items:center;padding:0;margin:0;border:0;background:0 0;height:8px;width:8px;min-height:8px;min-width:8px;max-height:8px;max-width:8px;cursor:pointer}.icon.arrow-downward{color:#999;border-style:solid;border-width:4px 4px 0;border-color:#999 transparent transparent;content:'';transition:transform .2s linear;cursor:pointer}.icon.arrow-downward.active{transform:rotate(180deg)}.vue-select{position:relative;display:flex;align-items:flex-start;justify-content:flex-start;flex-direction:column;width:150px;border-radius:4px;border:1px solid #999;box-sizing:border-box;outline:0}.vue-select[data-is-focusing=true]:not([data-visible-length='0']){border-bottom-left-radius:0;border-bottom-right-radius:0}.vue-select.disabled{background-color:rgba(239,239,239)}.vue-dropdown[data-removable=false] .vue-dropdown-item.selected:hover,.vue-select.disabled *,.vue-select.disabled input,.vue-tags[data-removable=false] .vue-tag.selected img:hover{cursor:not-allowed}.vue-select-header{display:flex;width:100%;align-items:center;justify-content:space-between}.vue-select-header .icon.arrow-downward,.vue-select-header .icon.loading,.vue-tag span{margin-right:4px}.vue-tags{display:flex;flex-wrap:wrap;margin:0;padding:2px;min-height:calc(1rem + 4px);user-select:none}.vue-tags.collapsed{flex-wrap:nowrap;overflow:auto}.vue-tag{display:none;align-items:center;list-style-type:none;border-radius:4px;margin:2px;min-height:1rem}.vue-tag,.vue-tag.selected{justify-content:center;background-color:#999;padding:0 4px;font-size:.8rem}.vue-dropdown,.vue-input{min-width:0;box-sizing:border-box}.vue-input,.vue-tag.selected{display:flex;align-items:center;border-radius:4px}.vue-input{max-width:100%;padding:4px}.vue-select[data-is-focusing=false] .vue-input input,input[readonly]{cursor:default}.vue-input,.vue-input input{border:0;outline:0;width:100%}.vue-input input{min-width:0;font-size:.8rem;padding:0}.vue-input input[disabled]{background-color:rgba(239,239,239)}.vue-input input[readonly],.vue-select-header .vue-input input[disabled]{background-color:unset}.vue-dropdown{position:absolute;background-color:#fff;z-index:1;max-height:300px;overflow-y:auto;width:inherit;left:-1px;margin:0;padding:0;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border:1px solid #999;list-style-type:none}.vue-dropdown[data-visible-length='0']{border:0}.vue-dropdown-item{list-style-type:none;padding:4px;cursor:pointer;min-height:1rem}.vue-dropdown-item.highlighted{background-color:#41b883}.vue-dropdown-item.disabled{background-color:rgba(239,239,239);cursor:not-allowed}.vue-dropdown-item.selected{background-color:#f3f3f3}.vue-dropdown-item.selected.highlighted{background-color:#ff6a6a}.vue-dropdown[data-addable=false][data-multiple=true] .vue-dropdown-item:not(.selected):hover{cursor:not-allowed}.icon.loading{display:inline-block;position:relative;width:8px;min-width:8px;height:8px;min-height:8px}.icon.loading div{box-sizing:border-box;display:block;position:absolute;border:1px solid #999;width:8px;height:8px;border-radius:50%;animation:loading 1s cubic-bezier(.5,0,.5,1) infinite;border-color:#999 transparent transparent}.icon.loading div:nth-child(1){animation-delay:-.08s}.icon.loading div:nth-child(2){animation-delay:-.16s}.inline-flex{display:inline-flex}
</style>
